import React, { useState } from 'react'
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useDispatch } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { fetchData } from '../reduxactions/donorrsactions/DDonationAction';
import { useNavigate } from 'react-router-dom';
import { GFNButton } from '../ui';
import { Panel } from 'primereact/panel';

export const DonorDonations = () => {

    const [globalFilter, setGlobalFilter] = useState('');


    const uid = window.sessionStorage.getItem('uid');
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const data = useSelector((state: RootState) => state.ddonation.data);


    // To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchData(uid) as any);
        } catch (error) {
            console.error('Error fetching data', error)
        }
    }
    useEffectOnce(() => {
        fetchDataAsync();
    }, [dispatch])

    const [acceptfield, setfield] = useState(false);
    const cancelfield = () => {
        setfield(false);
    }
    //To assign data 
    const [assignData, setassignData] = useState({
        Id: '',
    });

    const Donates = () => {
        const url = `/newdonations`;

        // Use navigate to navigate to the URL
        navigate(url);
    };
    const viewupload = (rowData: any) => {
        const url = `/chat/${rowData.donationID}`;

        // Use navigate to navigate to the URL
        navigate(url);
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/donor-Donation-Process.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };

    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        {/* <section className="content-header">
                            <div className="container-fluid">
                                <div className="grid mb-2">
                                    <div className="col-9">
                                        <h1>Donations</h1>
                                    </div>
                                    <div className="col-3">
                                        <a
                                            title="help"
                                            onClick={(e) => openWindow(e, IUrl)}
                                            style={{

                                                color: "blue",
                                                fontSize: 15, cursor: "pointer"
                                            }}
                                        >Help for this Page &nbsp;
                                            <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                        </a>
                                    </div>
                                </div>
                            </div>
                        </section> */}
                        <section className="app-page-header">
                            <div>
                                <h1 className="app-page-title">Donations</h1>
                            </div>
                            <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                Help for this Page
                                <i className="pi pi-question-circle"></i>
                            </a>
                        </section>
                        {/* <section className="content"> */}
                        <Panel>
                            <div className="grid">
                                <div className="col-12">
                                    <div className="card card-primary">
                                        <div className="card flex flex-wrap justify-content-end">
                                            {/* <Button className='mr-1' severity="info" label="New Donation" rounded onClick={() => Donates()} /> */}
                                            <GFNButton label="New Donation" icon="pi pi-plus" testId="new-donation-btn" className='mr-1' buttonType="secondary" rounded onClick={() => Donates()} />
                                        </div>

                                        <div className="card flex flex-wrap justify-content-end my-2">
                                            <span className="p-input-icon-left">
                                                <i className="pi pi-search ml-2" />

                                                <InputText
                                                    className="app-search-input"
                                                    value={globalFilter}
                                                    onChange={(e) => setGlobalFilter(e.target.value)}
                                                    placeholder="Global Search"
                                                />
                                            </span>
                                        </div>
                                        <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                            {/* <Column field="donationID" sortable header="DonationID"></Column> */}
                                            <Column field="nameoftheorg" sortable header="Organization Name"></Column>
                                            <Column field="name" sortable header="Fund Manager Name"></Column>
                                            <Column field="CreateDate" sortable header="Donor Date"></Column>
                                            <Column field="budget_amount" sortable header="Budget Amount"></Column>
                                            <Column field="self_amount" sortable header="Donated Amount"></Column>
                                            <Column field="received_amount" sortable header="Total Received Amount"></Column>
                                            <Column field="donationStatus" sortable header="Status"></Column>
                                            <Column header="Option" body={(rowData, { rowIndex }) => (
                                                <div>
                                                    {/* <Button data-testid={`view-btn-${rowIndex}`} className='mr-1' tooltip="Chat" severity="info" icon="pi pi-comments" rounded outlined onClick={() => viewupload(rowData)} /> */}
                                                    <GFNButton testId={`view-btn-${rowIndex}`} className='mr-1' tooltip="Chat" icon="pi pi-comments" rounded outlined buttonType="secondary" onClick={() => viewupload(rowData)} />
                                                </div>
                                            )}></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        {/* </section> */}
                    </div>
                </div>
            </div>
        </div>
    )
}